export const ARCHIVE_AUTOMATION_MODE_OPTIONS = [
  { value: 'manual_review', label: 'Review every game manually' },
  { value: 'assisted_review', label: 'Assist me, but I approve archives' },
  { value: 'auto_vod_truth_manual_approval', label: 'Verify games automatically, I approve archives' },
  { value: 'auto_approve_manual_publish', label: 'Prepare archives automatically, I publish' },
  { value: 'auto_publish_verified_games', label: 'Automatically archive verified games' },
  { value: 'exceptions_only_autopilot', label: 'Autopilot with exceptions only' },
] as const;

export function isAutoApproveDisabled(
  mode: string,
  autoRunVodTruth: boolean
): boolean {
  return mode === 'manual_review' || !autoRunVodTruth;
}

export function isAutoPublishDisabled(
  mode: string,
  autoRunVodTruth: boolean,
  autoApprove: boolean
): boolean {
  return isAutoApproveDisabled(mode, autoRunVodTruth) || !autoApprove;
}
